/* eslint-disable import/exports-last */
import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { type LayoutProps, PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]/manage/live-widgets/milestones/[...milestonesParams]'
export const MilestonesPageKeys = {
  Settings: 'settings',
  Display: 'display',
  // TODO: comes in the next stage
  // Data: 'data',
} as const
export type MilestonesPageKeys = (typeof MilestonesPageKeys)[keyof typeof MilestonesPageKeys]
export type MilestonesParams = [typeof MilestonesPageKeys.Settings, string] | [MilestonesPageKeys] | undefined
type ParamsTypeMap = { '...milestonesParams': MilestonesParams }
export const getPageUrl = toPathFactory<typeof pageUrl, ParamsTypeMap>(pageUrl, getPublicUrl)
export type FundraisingEventMilestonesPageProps = PageProps<
  typeof pageUrl,
  Record<string, string | string[] | undefined>,
  ParamsTypeMap
>
export type FundraisingEventMilestonesLayoutProps = LayoutProps<
  typeof pageUrl,
  'settings' | 'display' | 'preview',
  ParamsTypeMap
>
